module.exports = __webpack_public_path__ + "img/Burger-El-Cubano-Max-Quality.be05ebf1.jpg";